import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Empty, Spin } from "antd";
import { useTranslation } from "../../i18n/LanguageContext";
import API_URL from "../../apiBase";
import "./style.css";

const Events = () => {
    const { t, lang } = useTranslation();
    const navigate = useNavigate();
    const [items, setItems] = useState(null); // null = loading

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/api/portfolio?lang=${lang}`);
                const data = await res.json();
                if (!cancelled) setItems(Array.isArray(data.items) ? data.items : []);
            } catch {
                if (!cancelled) setItems([]);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [lang]);

    return (
        <div className="main-content-wrapper">
            <div className="eventsPage">
                <h2>{t("page.events.title")}</h2>
                <p>{t("events.intro")}</p>

                {items === null ? (
                    <div style={{ padding: 48, textAlign: "center", width: "100%" }}>
                        <Spin />
                    </div>
                ) : items.length === 0 ? (
                    <Empty description={null} style={{ width: "100%" }} />
                ) : (
                    <div className="eventsGrid">
                        {items.map((it) => (
                            <button
                                type="button"
                                key={it._id}
                                className="eventCard"
                                onClick={() => navigate(`/events/${it._id}`)}
                            >
                                <div className="eventCard__imgWrap">
                                    <img
                                        className="eventCard__img"
                                        src={`${it.image}${it.image.includes("?") ? "&" : "?"}w=600&auto=format`}
                                        alt={it.title || "Միջոցառում"}
                                        loading="lazy"
                                    />
                                    {it.photoCount > 1 && (
                                        <span className="eventCard__count">
                                            {it.photoCount} 📷
                                        </span>
                                    )}
                                </div>
                                {it.title ? (
                                    <span className="eventCard__title">{it.title}</span>
                                ) : null}
                            </button>
                        ))}
                    </div>
                )}

                <a href="/#app" className="joinBtn">
                    {t("events.cta")}
                </a>
            </div>
        </div>
    );
};

export default Events;
